Vue.component("editor-trumbowyg", require("./EditorTrumbowyg.vue").default);
Vue.component("editor-vueeditor", require("./VueEditor.vue").default);
Vue.component("countdown-time", require("./CountDown.vue").default);
Vue.component("loading-custom", require("./Loading.vue").default);
Vue.component("count-character", require("./CountCharacter.vue").default);
